import * as CryptoJS from 'crypto-js';


// btoa/atob trabajan sobre bytes: solo aceptan code units <= U+00FF.
// Convertimos a UTF-8 antes de codificar para admitir cualquier carácter
// (apóstrofos tipográficos, comillas curvas, emojis) sin que btoa lance
// InvalidCharacterError.
const toBinaryUtf8 = (value: string): string => {
    const bytes = new TextEncoder().encode(value);
    let binary = '';
    bytes.forEach(byte => binary += String.fromCharCode(byte));
    return binary;
};

const fromBinaryUtf8 = (binary: string): string => {
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }
    // fatal: true hace que un valor guardado con el formato anterior (latin1)
    // falle aquí en vez de decodificarse con caracteres de reemplazo.
    return new TextDecoder('utf-8', { fatal: true }).decode(bytes);
};

export class EncryptTools {

    encrypt(element: any): string {
        const STRING_ELEMENT = JSON.stringify(element);
        const ELEMENT_ENCRYPTED = btoa(toBinaryUtf8(STRING_ELEMENT));
        return ELEMENT_ENCRYPTED;
    }

    desencrypt(element: string): any {
        if (!element || element.trim() === '') { return false; }

        let binary: string;
        try {
            binary = atob(element);
        } catch (err) {
            return false;
        }

        // Formato actual: UTF-8.
        try {
            return JSON.parse(fromBinaryUtf8(binary));
        } catch (err) { }

        // Formato anterior: latin1. Mantiene vivas las sesiones ya guardadas
        // en localStorage antes de este cambio.
        try {
            return JSON.parse(binary);
        } catch (err) {
            return false;
        }
    }

}

export const encrypt = (keys, value) => {
    var key = CryptoJS.enc.Utf8.parse(keys);
    var iv = CryptoJS.enc.Utf8.parse(keys);
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value), key,
        {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

    return encrypted.toString();
}

export const decrypt = (keys, value) => {
    var key = CryptoJS.enc.Utf8.parse(keys);
    var iv = CryptoJS.enc.Utf8.parse(keys);
    var decrypted = CryptoJS.AES.decrypt(value, key, {
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
}
// export const encryptDataConection = async (
//     data: { [key: string]: boolean | string | number | [] | {} },
//     secret_encrypt: string
// ): Promise<string> => {
//     //SE OBTIENE UN RANGO DE BYTES PARA ENCRIPTAR
//     const random_byte = await randomBytes(16);
//     //SE CREA EL CIFRADO DEL STRING
//     const cipher = createCipheriv(
//         "aes-256-gcm",
//         scryptSync(secret_encrypt, "salt", 32),
//         random_byte
//     );
//     //SE ENCRIPTA LA DATA Y SE OPTIENE EL BUFFER
//     let encrypted = cipher.update(JSON.stringify(data));
//     //SE MODIFICA EL BUFFER ANTERIOR PARA CONCATENAR UN CIFRADO
//     encrypted = Buffer.concat([encrypted, cipher.final()]);
//     //SE RETORNA LA CADENA ENCRIPTADA
//     return random_byte.toString("hex") + ":" + encrypted.toString("hex");
// };
// export const decrypt = (data: string, secret_encrypt: string) => {
//     //SE PARTE EL STRING ENCRIPTADO ENTRE EL RANDOM_BYTE Y EL TEXTO ENCRIPTADO
//     const data_part = data.split(":");
//     //SE OBTIENE EL BUFFER DEL RANDOMB_BYTE
//     const random_byte = Buffer.from(data_part.shift(), "hex");
//     //SE OBTIENE EL BUFFER DE LA DATA ENVIADA
//     const decrypted_data = Buffer.from(data_part.join(":"), "hex");
//     //SE GENERA EL DECIFRADO
//     const decipher = createCipheriv(
//         "aes-256-gcm",
//         scryptSync(secret_encrypt, "salt", 32),
//         random_byte
//     );
//     //SE DESENCRIPTAN LOS DATOS Y SE OBTIENE EL BUFFER
//     let decrypted = decipher.update(decrypted_data);
//     //SE CONCATENA EL BUFFER CON EL CIFRADO PARA DESCENCRIPTAR POR TOTAL LOS DATOS
//     decrypted = Buffer.concat([decrypted, decipher.final()]);
//     //SE RETORNA LOS DATOS DESENCRIPTADOS
//     return JSON.parse(decrypted.toString());
// };

// export const encrypt = (
//     data: { [key: string]: boolean | string | number | [] | {} },
//     secret_encrypt: string
// ): string =>
//     createCipher("aes-256-ctr", secret_encrypt).update(
//         `${secret_encrypt}+${JSON.stringify(data)}+${secret_encrypt}`,
//         "hex",
//         "utf8"
//     );
// export const decrypt = (data: string, secret_encrypt: string) =>
//     createDecipher("aes-256-ctr", secret_encrypt).update(
//         `${secret_encrypt}+${data}+${secret_encrypt}`,
//         "hex",
//         "utf8"
//     );